// app/javascript/controllers/selectcheck_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "form"]

  validate(event) {
    const hasValue = this.optionTargets.some(el => el.value !== "")
    if (!hasValue) {
      event.preventDefault()
      alert("Bitte entweder ein Dokument oder eine Sammlung auswählen.")
    }
  }
}

